import { CategoryId } from 'interfaces/meta'

// ===============================  DASHBOARD  ============================= //
// After 'Net Worth' header

export const PENDING_TRANSACTIONS_HINT = 'Pending transactions can\'t be recategorized.'
export const DASHBOARD_NETWORTH_HEADER_HINT = 'Net worth is calculated as assets minus debts.'
// After 'Credit Score' header
export const DASHBOARD_CREDIT_HEADER_HINT = 'These credit scores are calculated by TransUnion® based on the VantageScore 3.0 model. Scores are from 300 to 850 and higher scores indicate higher creditworthiness.'


// =============================  MONEY FLOWS  =========================== //
export const MARK_AS_TRANSFER_HINT = 'Note: Transfers are excluded from totals.'


// ============================  DEBTS / ASSETS  ========================= //
// Interest rates grey dot on Account
export const NO_EFFECTIVE_RATE = ' Your effective interest rate is not available for this account.'
export const PROVIDER_ERROR = `We're having trouble communicating with your account provider.`

// Interest rates red dot on Account
export const DEBTS_NON_COMPETITIVE_RATE = 'Your interest rate is higher than your peers for this account.'
export const DEBTS_COMPETITIVE_RATE = `The interest rate you're paying is competitive, but you could be paying less.`
// Interest Rates	'EFFECTIVE RATE VS. PEER RANGE' header
export const DEBTS_RATES_EFFECTIVE_HINT = 'Your effective interest rate is the rate you are actually paying considering your balances and payments. The green highlighted peer range shows the competitive rates that at least half your peers are paying.'
// Interest Rates	'OPPORTUNITIES' header
export const DEBTS_RATES_OPPORTUNITIES_HINT = `This is the estimated amount you can save if you had an effective interest rate in the middle of your peer's range (highlighted in green).`

// Interest Rates	'EFFECTIVE RATE VS. PEER RANGE' header
export const ASSETS_RATES_EFFECTIVE_HINT = 'Your effective interest rate is the rate you are actually earning considering your balances and transactions. The green highlighted peer range shows the competitive rates that at least half your peers are earning.'
// Interest Rates	'OPPORTUNITIES' header
export const ASSETS_RATES_OPPORTUNITIES_HINTS: Record<CategoryId, string> = {
  savings: `This is the estimated amount you can earn if your effective interest rate matched the best rate your peers are earning.`,
  cd: `This is the estimated amount you can earn if your effective interest rate matched the best rate your peers are earning.`,
  investment: `This is the estimated amount you can save if you did not pay any fees.`,
  asset_other: `This is the estimated amount you can save if you did not pay any fees.`,
}
// Interest rates red dot on Account
export const ASSETS_NON_COMPETITIVE_RATE = `The interest rate you're earning is lower than your peers for this account.`
export const ASSETS_NON_COMPETITIVE_FEES = `You may be able to reduce your fees for this account.`
export const ASSETS_COMPETITIVE_RATE = `The interest rate you're earning is competitive, but you could be earning more.`

// =============================== NETWORTH  ============================= //
// Net Worth Change	After 'Net Worth Change' header
export const NETWORTH_CHANGE_HINT = 'These are changes in net worth compared to the previous month. Positive changes indicate a month-over-month increase in net worth.'
// Total Inflows	After 'Total Inflows' header
export const NETWORTH_INFLOWS_HINT = 'Inflows are positive changes in the value of linked accounts and assets (as a result of income, investment gains, or lower debt balances for example).'
// Total Outflows	After 'Total Outflows' header
export const NETWORTH_OUTFLOWS_HINT = 'Outflows are negative changes in the value of linked accounts and assets (as a result of spending, investment losses, or higher debt balances for example).'


// =============================== CREDIT SCORE  ============================= //
// Credit Score	Account Overview	After '# OF OPEN ACCOUNTS'
export const CREDIT_ACCOUNTS_HINT = 'This is the number of open accounts listed on your TransUnion® credit report.'
// Credit Score	Account Overview	After ' TOTAL BALANCE'
export const CREDIT_BALANCE_HINT = 'This is the total amount owed on all your accounts.'
// Credit Score	Account Overview	After 'NUMBER OF INQUIRIES'
export const CREDIT_INQUIRIES_HINT = 'Inquiries are requests made by potential lenders to the credit agencies to check your creditworthiness. Having many inquiries can result in a lower credit score.'
// Credit Score	Account Overview	After 'AVAILABLE CREDIT'
export const CREDIT_AVAILABLE_HINT = 'This is the combined unused portion of your available credit lines.'
// Credit Score	Account Overview	After 'AGE OF CREDIT'
export const CREDIT_AGE_HINT = 'This is the age of your oldest account which is still open.'
// Credit Score	Account Overview	After 'ACCOUNT UTILIZATION'
export const CREDIT_UTILIZATION_HINT = 'This is your total credit card balance divided by your total available credit card limits. Having high utilization may hurt your credit score.'


// =============================== SETTINGS  ============================= //
export const CONTACT_EMAIL_HINT = 'Changing your email address does not change your Status User ID.'
export const INACTIVE_INSTITUTION_HINT = 'We are unable to refresh this account. If you changed its password, please update your login info.'
export const LAST_LOGIN_LOCATION_HINT = 'Approximate location based on IP address.'
